'use client';

import { Loader2 } from 'lucide-react';

export type SpinnerSize = 'xs' | 'sm' | 'md';

const sizeClasses: Record<SpinnerSize, string> = {
  xs: 'h-3.5 w-3.5',
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
};

export interface SpinnerProps {
  size?: SpinnerSize;
  className?: string;
  'aria-hidden'?: boolean;
}

export function Spinner({
  size = 'sm',
  className = '',
  'aria-hidden': ariaHidden = true,
}: SpinnerProps) {
  return (
    <Loader2
      className={`shrink-0 animate-spin ${sizeClasses[size]} ${className}`.trim()}
      aria-hidden={ariaHidden}
    />
  );
}
